import type { FC } from "react";
import {
  APIProvider as BaseAPIProvider,
  type APIProviderProps,
} from "@huub-web/backend";

import { useAppSettings } from "../../hooks/useAppSettings";

export const APIProvider: FC<APIProviderProps> = ({ ...props }) => {
  const { isVisualDebugEnabled } = useAppSettings();

  return <BaseAPIProvider {...props} debug={isVisualDebugEnabled} />;
};
